import { CURRENCIES } from '../utils/pricing';

const FLAGS = { EUR: '🇪🇺', USD: '🇺🇸', GBP: '🇬🇧' };

// Manual fallback next to the auto-detected currency, in case geo-IP gets it
// wrong (VPNs, corporate proxies, etc.) — see hooks/useCurrency.js.
export default function CurrencySelector({ currency, onChange, style }) {
  return (
    <div style={{display:'flex',gap:6,background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:9,padding:4,...style}}>
      {CURRENCIES.map(cur => (
        <button key={cur} type="button" onClick={() => onChange(cur)}
          style={{background: currency===cur ? 'var(--green-dim)' : 'transparent',
            border:'none', // var(--green) e' il verde dei RIEMPIMENTI: come testo, sul fondo chiaro,
            // si ferma a 4,39:1. Il colore e' in linea, quindi nessuna regola CSS
            // ambitata puo' correggerlo — si cambia il token qui (2026-09-02).
            color: currency===cur ? 'var(--green-text, var(--green))' : 'var(--text3)',
            padding:'6px 14px', borderRadius:7, cursor:'pointer',
            fontFamily:'JetBrains Mono,monospace', fontSize:12, fontWeight:700,
            transition:'all .15s'}}>
          {FLAGS[cur]} {cur}
        </button>
      ))}
    </div>
  );
}
